import { ChevronDown } from 'lucide-react'
import type { PropertyFaqItem } from '@/data/property-faq'
import './property-faq.scss'

export function PropertyFaqList({ items, idPrefix }: { items: readonly PropertyFaqItem[]; idPrefix: string }) {
  return (
    <div className="property-faq-list">
      {items.map((item) => (
        <details key={item.id} id={`${idPrefix}-${item.id}`}>
          <summary><h3>{item.question}</h3><ChevronDown size={19} aria-hidden="true" /></summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>
  )
}
